function pickFirst(...values) {
  return values.find((value) => value !== undefined && value !== null && String(value).trim() !== '');
}

function buildProfileName(ticket) {
  const profile = ticket?.profile || {};
  const firstName = pickFirst(profile.firstName, profile.first_name);
  const lastName = pickFirst(profile.lastName, profile.last_name);
  const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();
  return fullName || pickFirst(profile.email, profile.uid) || '-';
}

function buildAssignedName(ticket) {
  const assigned = ticket?.assigned || {};
  const firstName = pickFirst(assigned.firstName, assigned.first_name);
  const lastName = pickFirst(assigned.lastName, assigned.last_name);
  const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();
  return fullName || pickFirst(assigned.email, assigned.uid) || '-';
}

function normalizeTickets(payload) {
  if (Array.isArray(payload?.tickets)) return payload.tickets;
  if (payload?.tickets && typeof payload.tickets === 'object') return Object.values(payload.tickets);
  if (Array.isArray(payload)) return payload;
  return [];
}

export function mapTicketsResponseToDto(payload) {
  return normalizeTickets(payload).map((ticket, index) => ({
    key: String(pickFirst(ticket.uid, `ticket-${index}`)),
    uid: String(pickFirst(ticket.uid) || '').trim(),
    number: ticket.number ?? null,
    subject: pickFirst(ticket.subject) || '-',
    status: pickFirst(ticket.status) || 'new',
    priority: pickFirst(ticket.priority) || 'normal',
    category: pickFirst(ticket.category) || '-',
    profileId: String(pickFirst(ticket?.profile?.uid, ticket?.profile?.id) || '').trim(),
    profileName: buildProfileName(ticket),
    assignedId: String(pickFirst(ticket?.assigned?.uid, ticket?.assigned?.id) || '').trim(),
    assignedName: ticket.assigned ? buildAssignedName(ticket) : '',
    created: pickFirst(ticket.created, ticket.createdAt),
    updated: pickFirst(ticket.updated, ticket.updatedAt),
  }));
}

export function mapTicketTotal(payload) {
  return Number(payload?.total ?? 0);
}
